import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["blood-tests--image-carousel-component"];
  static targets = ["confirm"];

  // Confirm and Continue is active only when the test date is filled in and at least one
  // included Observation row is valid — analyte, result, and unit, as stamped on the row by
  // ObservationFormComponent. Runs on page load, as the date is typed (the manual-entry date
  // only persists at confirmation), and after Turbo changes the rows.
  refreshConfirmGate() {
    if (!this.hasConfirmTarget) return;

    const dateInput = this.element.querySelector('input[type="date"]');
    const dateComplete = dateInput ? dateInput.value !== "" : true;
    const hasValidRow = !!this.element.querySelector(
      '.observation-row.included[data-observation-valid="true"]'
    );

    this.confirmTarget.disabled = !(dateComplete && hasValidRow);
  }

  // Editing a row's fields re-renders the row via a Turbo stream whose swap Turbo schedules
  // after its own events fire, so the gate watches the DOM itself: any row being added,
  // removed, replaced, or re-stamped triggers a re-check. The observer ignores the button's
  // own disabled attribute, so re-checking never re-triggers it.
  connect() {
    this.refreshConfirmGate();

    this.rowObserver = new MutationObserver(() => this.refreshConfirmGate());
    this.rowObserver.observe(this.element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-observation-valid"],
    });
  }

  highlight({ detail: { regionToHighlight } }) {
    if (!this.hasBloodTestsImageCarouselComponentOutlet) return;
    this.bloodTestsImageCarouselComponentOutlet.highlightRegion(regionToHighlight);
  }

  disconnect() {
    this.rowObserver?.disconnect();
  }
}
